/**
 * @type {number}
 */
let counter = 0;

/**
 * Large Data Set
 */
class DataSet {
	/**
	 * Class constructor
	 */
	constructor() {
		/**
		 * @type {Map<string, T_DataSetItem[]>}
		 * @private
		 */
		this._index = new Map();
		/**
		 * @type {Map<string, T_DataSetItem>}
		 * @private
		 */
		this._data = new Map();
	}

	/**
	 * Clears all data
	 *
	 * @returns {void}
	 */
	clear() {
		this._data.clear();
		this._index.clear();
	}

	/**
	 * Sets data and returns it's key
	 *
	 * @param {string} data
	 * @returns {T_DataSetItem}
	 */
	setData(data) {
		let len = data.length, checkKey = len + '@@';
		for (let i = 0, step = Math.max(1, Math.round(len / 6)); i < len; i += step) {
			checkKey += i + data[i];
		}
		let index = this._index.get(checkKey);
		if (index) {
			for (let item of index) {
				if (item.data === data) {
					return item;
				}
			}
		}
		let key = (++counter) + '_' + Date.now(),
			item = {key, data, checkKey};
		if (index) {
			index.push(item);
		} else {
			this._index.set(checkKey, [item]);
		}
		this._data.set(key, item);
		return item;
	}

	/**
	 * Returns data by the specified key.
	 * Returns NULL if data not found.
	 *
	 * @param {string} key
	 * @returns {?T_DataSetItem}
	 */
	getData(key) {
		let item = this._data.get(key);
		return item || null;
	}

	/**
	 * Deletes data by the specified key
	 *
	 * @param {string} key
	 * @returns {DataSet}
	 */
	deleteData(key) {
		let item = this._data.get(key);
		if (item) {
			this._data.delete(key);
			let index = this._index.get(item.checkKey);
			if (index) {
				let i = index.indexOf(item);
				if (i > -1) {
					index.splice(i, 1);
				}
				if (index.length === 0) {
					this._index.delete(item.checkKey);
				}
			}
		}
		return this;
	}

	/**
	 * Deletes all items except the specified ones
	 *
	 * @param {Array<string>} items
	 * @returns {void}
	 */
	deleteAllExcept(items) {
		let toDelete = [...this._data.keys()].filter(item => items.indexOf(item) === -1);
		for (let key of toDelete) {
			this.deleteData(key);
		}
	}
}

export default DataSet;
